import { render, staticRenderFns } from "./ResetChangePassword.vue?vue&type=template&id=741cdb44&scoped=true&"
import script from "./ResetChangePassword.vue?vue&type=script&lang=js&"
export * from "./ResetChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741cdb44",
  null
  
)

export default component.exports